// read-only LoginProvider
import React, { createContext, useContext, useEffect, useState } from "react"
import JWTApi, { IUser } from "../../libs/login/JWTApi"
import _ from "lodash"

type TAuthProvider = {
    isLoggedIn:boolean,
    ready:boolean
}

interface TAuthContextProps {
    api:JWTApi
    children:JSX.Element
}

const AuthContext = createContext<TAuthProvider>({} as any)
export const useAuth = () => useContext(AuthContext)

export default function AuthProvider(props:TAuthContextProps) {
    const {api} = props
    const [ready,setReady] = useState<boolean>(false)
    const [isLoggedIn,setIsLoggedIn] = useState<boolean>(false)

    const onAuth = (user:IUser|null) => {
        setReady(true)
        setIsLoggedIn(!!user) 
    }

    useEffect(() => {
        api.onAuth(onAuth)
        return () => { api.removeListener("auth", onAuth) }
    }, [])

    return <AuthContext.Provider value={{isLoggedIn,ready}}>
        {props.children}
    </AuthContext.Provider>
}